import { ClearPackageCache } from "@/helper/cacheHelper";
import { CheckBroadcastIsSupport } from "../../broadcastChannel/tabChannel";
import {
  BroadcastAuthenticatedNotificationStatus,
  BroadcastCacheUpdateSelectedMerchant,
  BroadcastCacheUpdateUserProfile,
  BroadcastDisconnectNotificationAllTab,
  BroadcastIsUpdateAllNotificationList,
  BroadcastIsUpdateIsSeenNotificationList,
  BroadcastIsUpdateNotificationCount,
  BroadcastIsUpdateUnSeenNotificationList,
} from "../../broadcastChannel/userChannel";
import Enums from "../../enums/enums";
import userInfo from "../../function/userInfo";
import helper from "../../helper/mainHelper";
import {
  DoAddNotificationCount,
  DoAddReadNotificationList,
  DoAddUnreadNotificationList,
  DoDeleteNotificationByIdFromSOCKET,
  DoGetNotificationCount,
  DoGetReadAllNotificationList,
  DoGetUnreadAllNotificationList,
  DoSetNotificationIsSeenAllFromSOCKET,
  DoSetNotificationIsSeenByIdFromSOCKET,
  RemoveSocketSessionIdFromCookies,
  SetIsSeenForNotification,
  SetSocketSessionIdFromCookies,
  SocketAuthentication,
  SortDataNotification,
} from "../../helper/notificationHelper";
import { IsMasterTabAvailable } from "../../helper/tabHelper";
import { CheckIndexedDBIsSupport } from "../../IndexedDB/tabIndexedDB";
import notificationService from "../../service/notification/notificationService";
import store from "../baseController";
export const mutations = {
  SOCKET_authenticated(state, payload) {
    if (payload) {
      state.notificationIsAuthenticated = true;
      state.notificationReadyToUse = true;
      SetSocketSessionIdFromCookies();
      BroadcastAuthenticatedNotificationStatus(Enums.AuthenticatedNotification.Success);
      BroadcastDisconnectNotificationAllTab();
    } else {
      state.notificationReadyToUse = false;
      RemoveSocketSessionIdFromCookies();
      BroadcastAuthenticatedNotificationStatus(Enums.AuthenticatedNotification.Failed);
    }
  },
  SOCKET_connect(state) {
    state.notificationIsConnect = true;
    SocketAuthentication();
  },
  SOCKET_disconnect(state) {
    state.notificationIsConnect = false;
    state.notificationIsAuthenticated = false;
    if (!IsMasterTabAvailable()) {
      state.notificationReadyToUse = false;
    }
  },
  async SOCKET_SendNotificationChanged(state, payload) {
    state.notificationCountLoadingStatus = Enums.LoadingStatusType.Loading;

    let merchantId = userInfo.MerchantId();
    const { status, data } = await notificationService.DoGetUnseenNotificationCount(payload.merchantId);
    let notificationCount = 0;

    if (status.IsSuccess()) {
      notificationCount = data.notificationCount;
    }

    if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
      await DoAddNotificationCount(payload.merchantId, notificationCount);
      if (payload.merchantId == merchantId) {
        state.notificationCount = await DoGetNotificationCount(merchantId);
      }
    } else {
      state.notificationCount = notificationCount;
    }
    setTimeout(() => {
      if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
        BroadcastIsUpdateNotificationCount(payload.merchantId);
      }
      state.notificationCountLoadingStatus = Enums.LoadingStatusType.Success;
    }, 0);
  },
  async SOCKET_RemoveNotificationById(state, payload) {
    if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
      await DoDeleteNotificationByIdFromSOCKET(payload.merchantId, payload.notificationId);
    }
  },

  async SOCKET_IsSeenNotificationById(state, payload) {
    if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
      await DoSetNotificationIsSeenByIdFromSOCKET(payload.merchantId, payload.notificationId);
    }
  },

  async SOCKET_IsSeenAllNotification(state, payload) {
    if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
      await DoSetNotificationIsSeenAllFromSOCKET(payload.merchantId);
    }
  },

  async MutationGetNotificationCount(state, payload) {
    state.notificationCountLoadingStatus = Enums.LoadingStatusType.Loading;

    let merchantId = userInfo.MerchantId();
    if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
      await DoAddNotificationCount(payload.merchantId, payload.notificationCount);
      if (payload.merchantId == merchantId) {
        state.notificationCount = await DoGetNotificationCount(merchantId);
      }
    } else {
      state.notificationCount = payload.notificationCount;
    }
    setTimeout(() => {
      if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
        BroadcastIsUpdateNotificationCount(payload.merchantId);
      }
      state.notificationCountLoadingStatus = Enums.LoadingStatusType.Success;
    }, 0);
  },

  async MutationGetAllNotificationList(state, payload) {
    state.notificationListLoadingStatus = Enums.LoadingStatusType.Loading;
    const merchantId = userInfo.MerchantId();
    state.notificationList = [];
    if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
      await DoAddUnreadNotificationList(payload.merchantId, payload.unreadNotificationList);
      await DoAddReadNotificationList(payload.merchantId, payload.readNotificationList);
      if (payload.merchantId == merchantId) {
        const unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
        state.unSeenNotificationList = SetIsSeenForNotification(unreadNotificationList, false);
        const readNotificationList = await DoGetReadAllNotificationList(merchantId);
        state.isSeenNotificationList = SetIsSeenForNotification(readNotificationList, true);
      }
    } else {
      state.unSeenNotificationList = SetIsSeenForNotification(payload.unreadNotificationList, false);
      state.isSeenNotificationList = SetIsSeenForNotification(payload.readNotificationList, true);
    }

    setTimeout(() => {
      if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
        BroadcastIsUpdateAllNotificationList(payload.merchantId);
      }
      state.notificationListLoadingStatus = Enums.LoadingStatusType.Success;
    }, 0);
  },

  async MutationGetUnSeenNotificationList(state, payload) {
    state.notificationListLoadingStatus = Enums.LoadingStatusType.Loading;
    const merchantId = userInfo.MerchantId();
    if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
      await DoAddUnreadNotificationList(payload.merchantId, payload.unreadNotificationList);
      if (payload.merchantId == merchantId) {
        const unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
        state.unSeenNotificationList = SetIsSeenForNotification(unreadNotificationList, false);
      }
    } else {
      state.unSeenNotificationList = SetIsSeenForNotification(payload.unreadNotificationList, false);
    }

    setTimeout(() => {
      if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
        BroadcastIsUpdateUnSeenNotificationList(payload.merchantId);
      }
      state.notificationListLoadingStatus = Enums.LoadingStatusType.Success;
    }, 0);
  },

  async MutationGetIsSeenNotificationList(state, payload) {
    state.notificationListLoadingStatus = Enums.LoadingStatusType.Loading;
    const merchantId = userInfo.MerchantId();
    state.isSeenNotificationList = [];
    if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
      await DoAddReadNotificationList(payload.merchantId, payload.readNotificationList);
      if (payload.merchantId == merchantId) {
        const readNotificationList = await DoGetReadAllNotificationList(merchantId);
        state.isSeenNotificationList = SetIsSeenForNotification(readNotificationList, true);
      }
    } else {
      state.isSeenNotificationList = SetIsSeenForNotification(payload.readNotificationList, true);
    }

    setTimeout(() => {
      if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
        BroadcastIsUpdateIsSeenNotificationList(payload.merchantId);
      }
      state.notificationListLoadingStatus = Enums.LoadingStatusType.Success;
    }, 0);
  },

  MutationSetNotificationListLoadingStatus(state, status) {
    state.notificationListLoadingStatus = status;
  },

  MutationSetNotificationReadyToUse(state, status) {
    state.notificationReadyToUse = status;
  },

  async MutationSetAllNotificationListFromIndexedDB(state) {
    state.notificationListLoadingStatus = Enums.LoadingStatusType.Loading;
    let merchantId = userInfo.MerchantId();
    let unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
    unreadNotificationList = SetIsSeenForNotification(unreadNotificationList, false);
    state.unSeenNotificationList = SortDataNotification(unreadNotificationList);
    let readNotificationList = await DoGetReadAllNotificationList(merchantId);
    readNotificationList = SetIsSeenForNotification(readNotificationList, true);
    state.isSeenNotificationList = SortDataNotification(readNotificationList);

    setTimeout(() => {
      state.notificationListLoadingStatus = Enums.LoadingStatusType.Success;
    }, 0);
  },

  async MutationSetUnSeenNotificationListFromIndexedDB(state) {
    state.notificationListLoadingStatus = Enums.LoadingStatusType.Loading;
    let merchantId = userInfo.MerchantId();
    let unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
    unreadNotificationList = SetIsSeenForNotification(unreadNotificationList, false);
    state.unSeenNotificationList = SortDataNotification(unreadNotificationList);

    setTimeout(() => {
      state.notificationListLoadingStatus = Enums.LoadingStatusType.Success;
    }, 0);
  },

  async MutationSetIsSeenNotificationListFromIndexedDB(state) {
    state.notificationListLoadingStatus = Enums.LoadingStatusType.Loading;
    let merchantId = userInfo.MerchantId();
    let readNotificationList = await DoGetReadAllNotificationList(merchantId);
    readNotificationList = SetIsSeenForNotification(readNotificationList, true);
    state.isSeenNotificationList = SortDataNotification(readNotificationList);

    setTimeout(() => {
      state.notificationListLoadingStatus = Enums.LoadingStatusType.Success;
    }, 0);
  },

  async MutationSetNotificationCountFromIndexedDB(state) {
    state.notificationCountLoadingStatus = Enums.LoadingStatusType.Loading;
    let merchantId = userInfo.MerchantId();
    state.notificationCount = await DoGetNotificationCount(merchantId);
    setTimeout(() => {
      state.notificationCountLoadingStatus = Enums.LoadingStatusType.Success;
    }, 0);
  },

  async MutationSetNotificationFromActionIsSeen(state) {
    state.notificationListLoadingStatus = Enums.LoadingStatusType.Loading;
    let merchantId = userInfo.MerchantId();
    state.notificationCount = await DoGetNotificationCount(merchantId);
    let unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
    unreadNotificationList = SetIsSeenForNotification(unreadNotificationList, false);
    state.unSeenNotificationList = SortDataNotification(unreadNotificationList);
    let readNotificationList = await DoGetReadAllNotificationList(merchantId);
    readNotificationList = SetIsSeenForNotification(readNotificationList, true);
    state.isSeenNotificationList = SortDataNotification(readNotificationList);
    setTimeout(() => {
      state.notificationListLoadingStatus = Enums.LoadingStatusType.Success;
    }, 0);
  },
  MutationSetTransactionTypeListForMap(state, input) {
    const transactionNumberList = input.transactionNumberList;
    const transactionType = input.transactionType;

    if (transactionNumberList && transactionNumberList.length > 0) {
      let transactionCodeForMap = new Map();
      const transactionTypeOnLocal = state.transactionTypeListForMap.get(transactionType);
      if (transactionTypeOnLocal) {
        transactionCodeForMap = transactionTypeOnLocal;
      }

      for (const transactionNumber of transactionNumberList) {
        transactionCodeForMap.set(transactionNumber.id, transactionNumber);
      }

      state.transactionTypeListForMap.set(transactionType, transactionCodeForMap);
    }
  },
  MutationSetJournalViewDetailListForMap(state, journalViewDetailList) {
    if (journalViewDetailList && journalViewDetailList.length > 0) {
      for (const journalPaymentDetail of journalViewDetailList) {
        state.journalViewDetailListForMap.set(journalPaymentDetail.id, journalPaymentDetail);
      }
    }
  },
  MutationSetPaymentTransferViewDetailListForMap(state, paymentTransferViewDetailList) {
    if (paymentTransferViewDetailList && paymentTransferViewDetailList.length > 0) {
      for (const paymentTransferViewDetail of paymentTransferViewDetailList) {
        state.paymentTransferViewDetailListForMap.set(
          paymentTransferViewDetail.paymentGroupId,
          paymentTransferViewDetail
        );
      }
    }
  },
  MutationSetChequeViewDetailListForMap(state, chequeViewDetailList) {
    if (chequeViewDetailList && chequeViewDetailList.length > 0) {
      for (const chequeViewDetail of chequeViewDetailList) {
        state.chequeViewDetailListForMap.set(chequeViewDetail.id, chequeViewDetail);
      }
    }
  },

  MutationSetProductCodeListForMap(state, productTemplateCodeList) {
    if (productTemplateCodeList && productTemplateCodeList.length > 0) {
      for (const productTemplateCode of productTemplateCodeList) {
        state.productCodeListForMap.set(productTemplateCode.id, productTemplateCode);
      }
    }
  },

  MutationSetAssetTemplateCodeListForMap(state, assetTemplateCodeList) {
    if (assetTemplateCodeList && assetTemplateCodeList.length > 0) {
      for (const assetTemplateCode of assetTemplateCodeList) {
        state.assetTemplateCodeListForMap.set(assetTemplateCode.id, assetTemplateCode);
      }
    }
  },
  MutationSetBankAccountListForMap(state, bankAccountList) {
    if (bankAccountList && bankAccountList.length > 0) {
      for (const bankAccount of bankAccountList) {
        state.bankAccountIdListForMap.set(bankAccount.id, bankAccount);
      }
    }
  },
  async SOCKET_ResetCache(state, payload) {
    await helper.CheckAssetTokenValid();
    if (payload.cacheTypeList && payload.cacheTypeList.length > 0) {
      for (const cacheType of payload.cacheTypeList) {
        switch (cacheType) {
          case Enums.CacheType.UserProfile:
            await store.dispatch("DoGetUserInfoByUserId");
            setTimeout(() => {
              if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
                BroadcastCacheUpdateUserProfile();
              }
            }, 0);
            break;
          case Enums.CacheType.SelectedMerchant:
            const merchantId = userInfo.MerchantId();
            if (merchantId) {
              store.commit("MutationReSetMerchantModelList");

              const merchant = await store.dispatch("DoGetMerchantByResetCache", {
                merchantId: merchantId,
                isUseMainDatabase: true,
              });
              if (merchant) {
                store.commit("MutationSetSettingMerchantDetailLoadingStatus", Enums.LoadingStatusType.None);
                store.commit("MutationSetSettingMerchantAddressListLoadingStatus", Enums.LoadingStatusType.None);
                store.commit("MutationUpdateMerchantLockPeriodLoadingStatus", Enums.LoadingStatusType.None);
              }
              setTimeout(() => {
                if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
                  BroadcastCacheUpdateSelectedMerchant();
                }
              }, 0);
            }
            break;
          case Enums.CacheType.Package:
            await ClearPackageCache();
            break;
        }
      }
    }
  },
};
